export interface ContactRow {
  createdAt: string;
  displayName?: string | null;
  email: string;
  id: string;
  responderUser: string;
  sharedByMeGroupCount: number;
  sharedByMeSiteCount: number;
  sharedWithMeGroupCount: number;
  sharedWithMeSiteCount: number;
}

export interface IncomingRequestRow {
  createdAt: string;
  displayName?: string | null;
  email: string;
  id: string;
  seen: boolean;
}

export interface SentRequestRow {
  createdAt: string;
  email: string;
  id: string;
}

export interface BlockedUserRow {
  blockedAt: string;
  displayName?: string | null;
  userId: string;
}

export interface ContactSharedItem {
  id: string;
  kind: 'FIND_GROUP' | 'SITE';
  level: number;
  name: string;
}

export interface ContactDetailData {
  createdAt: string;
  displayName?: string | null;
  email: string;
  id: string;
  responderUser: string;
  sharedByMe: ContactSharedItem[];
  sharedWithMe: ContactSharedItem[];
}

export const getContactName = ({
  displayName,
  email,
}: Pick<ContactRow, 'displayName' | 'email'>) => displayName?.trim() || email;

export const getContactInitials = (
  contact: Pick<ContactRow, 'displayName' | 'email'>
) => {
  const parts = getContactName(contact)
    .split(/[\s@._-]+/)
    .filter(Boolean);

  return parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
};
